import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import { SERVICE_BOOKING_CREATE_PATH } from '@/services'

export const useCreateBookingRepair = (config = {}) => {
  const api = useLegacyPublicApi()
  const { formatMessage } = useIntl()
  const [errorMessage, setErrorMessage] = useState(null)

  const { mutateAsync: mutate, isLoading } = useMutation({
    mutationFn: async (data) => {
      if (!api || !data.phoneNumber || !data.regCode) return false
      setErrorMessage(null)
      const { data: responseData } = await api.post(
        SERVICE_BOOKING_CREATE_PATH,
        data,
      )
      return responseData
    },
    onError: (error) => {
      const errors = {
        302: 'block.booking.data-not-found',
        6302: 'block.booking.different-phone-number',
        6303: 'block.booking.vehicle-not-active',
        6095: 'block.booking.failure-to-send',
      }
      const serverErrorCode =
        error.response?.data?.length > 0 ? error.response.data[0].Code : 0
      const serverErrorMessage =
        error.response?.data?.length > 0
          ? error.response.data[0].Description
          : null
      if (errors[serverErrorCode])
        setErrorMessage(formatMessage({ id: errors[serverErrorCode] }))
      else if (serverErrorMessage) setErrorMessage(serverErrorMessage)
      else
        setErrorMessage(
          formatMessage({ id: 'block.booking.error-create-token' }),
        )
    },
    ...config,
  })
  const createBookingRepairTokenData = (data) => mutate(data)
  return { createBookingRepairTokenData, isLoading, errorMessage }
}

export default useCreateBookingRepair
